import React, { useState, useRef } from "react";

const AudioBlock = ({ title, url, list }) => {
  const [playingIndex, setPlayingIndex] = useState(null);
  const audioRefs = useRef([]);

  const toggleAudio = (index) => {
    const audio = audioRefs.current[index];

    if (playingIndex === index) {
      audio.pause();
      setPlayingIndex(null);
    } else {
      audioRefs.current.forEach((a, i) => {
        if (a && i !== index) a.pause();
      });

      audio.play();
      setPlayingIndex(index);
    }
  };

  return (
    <section className="videos">
      <div className="container">
        <div className="row">
          <div className="whitetitle">
            <h1>{title}</h1>
            <a className="webbutton d-none d-lg-block" href={url}>
              View More
            </a>
          </div>
        </div>

        <div className="row">
          {list.map((item, index) => (
            <div key={index} className="p-2 col-lg-3 col-md-3 col-sm-6 col-6">
              <div className="card audio-card text-center">
                <div style={{ position: "relative" }}>
                  <img
                    src={item.imagepath}
                    alt="Audio thumbnail"
                    className="rounded-circle img-fluid"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />

                 <button
  className="play-btn"
  onClick={() => toggleAudio(index)}
>
  {playingIndex === index ? "⏸" : "▶"}
</button>

               <audio
  ref={(el) => (audioRefs.current[index] = el)}
  preload="metadata"
>
  <source src={item.videopath} />
</audio>
                </div>

                <div className="card-body p-0">
                  <div className="card-title h6">
                    {item.title}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <a className="webbutton2 d-lg-none d-block" href={url}>
          View More
        </a>
      </div>
    </section>
  );
};

export default AudioBlock;